import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { getSenderId, getCurrentDialogId } from '../../store/selectors';

import s from './index.module.css';

import { ReactComponent as StarIcon } from './assets/star.svg';
import messagesApi from '../../api/messages';

const rates = ['ужасно', 'плохо', 'норма', 'хорошо', 'отлично'];

const RateExpert = ({ rate, messageId, expertId }) => {
  const currentDialogId = useSelector(getCurrentDialogId);
  const senderId = useSelector(getSenderId);
  const [currentRate, setCurrentRate] = useState(rate);
  const [isRated, setIsRated] = useState(Boolean(rate));

  const handleRateHover = (index) => () => {
    if (!isRated) {
      setCurrentRate(index);
    }
  };

  const handleSelectRate = (index) => () => {
    if (!isRated) {
      messagesApi.rateExpert(currentDialogId, expertId, senderId, index, messageId);
      setCurrentRate(index);
      setIsRated(true);
    }
  };

  return (
    <div className={s.wrapper}>
      <div className={s.title}>
        {isRated
          ? 'Эксперт не видит оценку'
          : 'Оцените работу эксперта. Это поможет улучшить качество работы в будущем. Эксперт не увидит оценку.'}
      </div>
      <div className={cn(s.content, { [s.isRated]: isRated })}>
        <div className={s.contentTitle}>Моя оценка</div>
        <div className={s.rates}>
          {rates.map((text, index) => (
            <div
              onClick={handleSelectRate(index + 1)}
              onMouseEnter={handleRateHover(index + 1)}
              onMouseLeave={() => !isRated && setCurrentRate(undefined)}
              className={cn(s.rate, { [s.activeRate]: currentRate >= index + 1 })}
              key={index}
            >
              <StarIcon />
              <div className={cn(s.contentText, { [s.hiddenText]: isRated && index + 1 !== currentRate })}>{text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

RateExpert.propTypes = {
  rate: PropTypes.number,
};

export default RateExpert;
